export const pricingTiers = [
  {
    id: 'issuer-desk',
    name: 'Issuer Desk',
    priceRange: 'USD 39-99 / user / month',
    purpose: 'AI-assisted preparation workspace for early issuer planning.',
    features: [
      'AI configuration wizard',
      'Draft issuer profile',
      'Document checklist',
      'Read-only workspace',
      'No certificate deployment',
    ],
  },
  {
    id: 'issuer-workspace',
    name: 'Issuer Workspace Bundle',
    priceRange: 'USD 500 / month bundle',
    purpose: 'Four issuer workspaces plus admission file, evidence vault, lane classifier, wallet coordination, and draft certificate configuration.',
    features: [
      'Up to 4 issuer workspaces included',
      'Issuer admission file preparation',
      'Evidence vault and document checklist',
      'Product lane classifier',
      'Wallet coordination and draft certificate configuration',
    ],
  },
  {
    id: 'certificate-program',
    name: 'Certificate Program',
    priceRange: 'From USD 750 / month',
    purpose: 'Operational certificate program with transfer controls and ledger administration. Setup is quoted separately where required.',
    features: [
      'Certificate deployment workflow',
      'Transfer restrictions',
      'Ledger administration',
      'Reporting exports',
      'Controlled transfer requests',
    ],
  },
  {
    id: 'regulated-program',
    name: 'Regulated / Fiduciary / Warrant Program',
    priceRange: 'From USD 2,500 / month',
    purpose: 'High-touch programs involving legal-opinion intake, fiduciary files, producer files, warrant files, or jurisdiction routing. Setup is quoted separately where required.',
    features: [
      'Enhanced compliance file',
      'Legal-opinion intake',
      'Fiduciary, producer, or warrant file handling',
      'Audit trail',
      'Jurisdiction routing',
    ],
  },
  {
    id: 'enterprise',
    name: 'Enterprise / White Label',
    priceRange: 'Custom',
    purpose: 'Dedicated infrastructure, custom integrations, and institutional workflows.',
    features: [
      'Dedicated deployment',
      'Custom workflows',
      'Wallet infrastructure planning',
      'API integrations',
      'Custom reporting',
    ],
  },
];

export const pricingDisclaimer =
  'Legal, trustee, fiduciary, tax, accounting, licensed-provider, blockchain gas, and third-party service costs are separate unless expressly included in a signed agreement.';
